import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { GET_TAB_CONFIG } from 'lib/api/queries';
import { actionSetTabs } from 'lib/actions';
import { useQuery } from '@apollo/client';
import _get from 'lodash/get';
import { DEFAULT_TABS } from 'lib/constants';
import { fetchGalleryApp } from 'lib/api/appGallery';
import { resolveAppTabs } from 'lib/tabs/resolveAppTabs';

const useTabsConfig = () => {
  const dispatch = useDispatch();
  // Resolution is async, so a later config must not be overwritten by an earlier one landing late.
  const passRef = useRef(0);

  useQuery(GET_TAB_CONFIG, {
    fetchPolicy: 'no-cache',
    onCompleted: ({ data: { templates } }) => {
      passRef.current += 1;
      const pass = passRef.current;
      const config = _get(templates, [0, 'config', 'tabs'], undefined);
      if (!Array.isArray(config)) {
        dispatch(actionSetTabs(DEFAULT_TABS));
        return;
      }

      // One dispatch, after resolution: routing picks the home tab from the first visible tab and
      // redirects unknown tab ids, so a partial list would send the operator to the wrong tab.
      // Each gallery lookup aborts on its own timeout, which bounds the wait.
      resolveAppTabs(config, fetchGalleryApp)
        .then((tabs) => {
          if (pass === passRef.current) {
            dispatch(actionSetTabs(tabs));
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.warn('app tabs: resolution failed', error);
          if (pass === passRef.current) {
            dispatch(
              actionSetTabs(
                config.filter((tab) => {
                  return tab.url || tab.appId == null;
                })
              )
            );
          }
        });
    },
  });
};

export { useTabsConfig };
